let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8WnsM")).then(() => parcelRequire('30CCJ'));